import eventRegistry from '../common/event-registry'

export function initSubscribe(HstRtcEngine) {
  /**
   * 订阅事件
   */  
  HstRtcEngine.prototype.subEvent = function () {
    console.log("Subscribe event: ", arguments[0]);
    eventRegistry.on(...arguments)
  }

  /**
   * 取消订阅事件，参数为空则为取消订阅所有事件
   */
  HstRtcEngine.prototype.unsubEvent = function () {
    console.log("Unsubscribe event: ", arguments[0]);
    eventRegistry.off(...arguments);  
  }
}